import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {
    IRevolutPaymentMethodViewModel
} from "../../../../services/booking/models/payment/methods/revolut/revolut-payment-method.view-model.interface";

const HeaderBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const RevolutMarketingTextBox = styled.div`
    position: absolute;
    font-size: ${props => props.theme.fontSize.caption};
    font-weight: ${props => props.theme.fontWeight.medium};
    bottom: 0;
    text-align: center;
    transform: translateY(-50%);
    white-space: nowrap;
   
    ${props => props.theme.containerMediaQuery.smallScreen} {
        white-space: normal;
        word-wrap: break-word;
        overflow-wrap: break-word;
        max-width: 64px;
        transform: translateY(0%);
    }
`

/*
const LogoSmallBox = styled.div`
    background-image: url(${props => props.theme.assets.images.payments.revolut_logo_small_svg.toString()});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 38px;
    height: 36px;
`
 */

const LogoLargeBox = styled.div`
    background-image: url(${props => props.theme.assets.images.payments.Revolut_Logo_Light_svg.toString()});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 110px;
    height: 65px;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        width: 95px;
        height: 55px;
    }
`

export const RevolutPaymentMethodTabHeaderComponent: React.FC<{paymentMethod: IRevolutPaymentMethodViewModel}> = observer((props) => {


    const renderPoints = () => {

        return (
            <RevolutMarketingTextBox>
                {props.paymentMethod.revolutPointsConfiguration.marketingText}
            </RevolutMarketingTextBox>
        );
    }

    /*
    const renderLogo = () => {
        if(screenMediaQuery.smallScreen) {
           return (
               <LogoLargeBox/>
           )
        }

        return (
            <LogoLargeBox/>
        );
    }
     */

    return (
        <HeaderBox>
            <LogoLargeBox/>
            {renderPoints()}
        </HeaderBox>
    );
})